import { Link } from 'react-router-dom';
import { Facebook, Instagram, Youtube } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-midnight px-2 sm:px-4 md:px-8 lg:px-12 xl:px-16 2xl:px-20 rounded-lg">
      <hr className="border-t border-gray-500 mb-4 mt-8" />
      <div className="grid grid-cols-2 sm:grid-cols-12 gap-4 pb-8 px-4 sm:px-0">
        <div className="col-span-2 sm:col-span-5 text-center sm:text-start">
          <h3 className="text-lg font-semibold mb-4">Notta</h3>
          <p className="text-sm w-full sm:w-[70%]">
            With a user-friendly interface, competitive pricing, and a wide variety of beats to choose from, our marketplace is the perfect destination for any music or artists.
          </p>
        </div>
        <div className="col-span-1 sm:col-span-2 text-center sm:text-start">
          <h3 className="text-lg font-semibold mb-4">Home</h3>
          <ul>
            <li><Link to="#" className="text-sm hover:underline">Search</Link></li>
            <li><Link to="#" className="text-sm hover:underline">Browse</Link></li>
            <li><Link to="#" className="text-sm hover:underline">How it works</Link></li>
            <li><Link to="#" className="text-sm hover:underline">Upload</Link></li>
          </ul>
        </div>
        <div className="col-span-1 sm:col-span-2 text-center sm:text-start">
          <h3 className="text-lg font-semibold mb-4">Music</h3>
          <ul>
            <li><Link to="#" className="text-sm hover:underline">Artists</Link></li>
            <li><Link to="#" className="text-sm hover:underline">Song</Link></li>
            <li><Link to="#" className="text-sm hover:underline">Album</Link></li>
            <li><Link to="#" className="text-sm hover:underline">Genre</Link></li>
          </ul>
        </div>
        <div className="col-span-1 sm:col-span-2 text-center sm:text-start">
          <h3 className="text-lg font-semibold mb-4">Explore</h3>
          <ul>
            <li><Link to="#" className="text-sm hover:underline">Events</Link></li>
            <li><Link to="#" className="text-sm hover:underline">Blog</Link></li>
            <li><Link to="#" className="text-sm hover:underline">Community</Link></li>
            <li><Link to="#" className="text-sm hover:underline">Security</Link></li>
          </ul>
        </div>
        <div className="col-span-1 sm:col-span-1 text-center sm:text-start">
          <h3 className="text-lg font-semibold mb-4">Support</h3>
          <ul>
            <li><Link to="#" className="text-sm hover:underline">Help center</Link></li>
            <li><Link to="#" className="text-sm hover:underline">Careers</Link></li>
            <li><Link to="#" className="text-sm hover:underline">Updates</Link></li>
            <li><Link to="#" className="text-sm hover:underline">Contact us</Link></li>
          </ul>
        </div>
      </div>
      <hr className="border-t border-gray-500 mb-2" />
      <div className="flex flex-col sm:flex-row justify-between px-4 sm:px-0">
        <div className="flex flex-col sm:flex-row items-center gap-4 sm:gap-7 mb-4 sm:mb-0">
          <Link to="#" className="text-sm hover:underline">&copy; 2023 All right reserved</Link>
          <Link to="#" className="text-sm hover:underline">Privacy Policy</Link>
          <Link to="#" className="text-sm hover:underline">Terms of Service</Link>
        </div>
        <div className="flex justify-center space-x-4 mb-2">
          <Link to="#" className="text-sm"><Instagram /></Link>
          <Link to="#" className="text-sm"><Facebook /></Link>
          <Link to="#" className="text-sm"><Youtube /></Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;